import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import logo from "../assets/logo.png.png";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSend = async () => {
    if (!email) { setError("Veuillez entrer votre adresse email"); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setError("Email invalide"); return; }

    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json();
        setError(data.error || "Une erreur s'est produite");
      }
    } catch {
      // même si le backend répond 404 on affiche succès (sécurité)
      setSent(true);
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* LEFT SIDE */}
        <div className="login-left">
          <div className="company-logo">
            <img src={logo} alt="LOGIMES Logo" />
          </div>
          <h1>Password Reset</h1>
          <p>
            Entrez votre adresse email et nous vous enverrons un lien pour
            réinitialiser votre mot de passe en toute sécurité.
          </p>
          <span className="footer-text"> Facturation electronique Logimes</span>
        </div>

        {/* RIGHT SIDE */}
        <div className="login-right" style={{ justifyContent: "center" }}>

          {!sent ? (
            <>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ fontSize: "2.5rem" }}>🔐</span>
              </div>
              <h2>Mot de passe oublié?</h2>
              <p className="subtitle">
                Pas de panique! Entrez votre email et nous vous enverrons un lien de réinitialisation.
              </p>

              {error && (
                <div style={{
                  background: "#fef0f0", border: "1.5px solid #fcc",
                  color: "#e74c3c", padding: "12px 16px", borderRadius: "10px",
                  fontSize: "0.88rem", fontWeight: 600, marginBottom: "16px"
                }}>
                  ⚠️ {error}
                </div>
              )}

              <div className="form-group">
                <label>Adresse Email</label>
                <input
                  type="email"
                  placeholder="Entrez votre email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(""); }}
                  onKeyDown={(e) => e.key === "Enter" && handleSend()}
                />
              </div>

              <button className="login-btn" onClick={handleSend} disabled={loading}>
                {loading ? "Envoi en cours..." : "📩 ENVOYER LE LIEN"}
              </button>

              <Link to="/" className="forgot-under" style={{ textAlign: "center", marginTop: "16px" }}>
                ← Retour à la connexion
              </Link>
            </>
          ) : (
            /* SUCCESS STATE */
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "4rem", marginBottom: "20px" }}>📬</div>
              <h2 style={{ marginBottom: "12px", color: "#1a1a2e" }}>Email envoyé!</h2>
              <p style={{ color: "#888", fontSize: "0.9rem", lineHeight: 1.6, marginBottom: "24px" }}>
                Un lien de réinitialisation a été envoyé à<br />
                <strong style={{ color: "#4f8cff" }}>{email}</strong><br /><br />
                Vérifiez votre boîte mail et suivez les instructions.<br />
                Le lien expire dans <strong>30 minutes</strong>.
              </p>

              <div style={{
                background: "#f8f7ff", border: "1.5px solid #ebebff",
                borderRadius: "12px", padding: "16px", marginBottom: "24px",
                fontSize: "0.82rem", color: "#888"
              }}>
                💡 Vous n'avez pas reçu l'email? Vérifiez vos spams ou{" "}
                <span
                  style={{ color: "#4f8cff", cursor: "pointer", fontWeight: 600 }}
                  onClick={() => { setSent(false); setEmail(""); }}
                >
                  réessayez
                </span>
              </div>

              <Link to="/" className="login-btn" style={{
                display: "block", textAlign: "center",
                textDecoration: "none", padding: "13px"
              }}>
                Retour à la connexion
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;


